import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDateStart = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M16 2V6M8 2V6M3 9H21M19 4H5C3.895 4 3 4.895 3 6V19C3 20.105 3.895 21 5 21H19C20.105 21 21 20.105 21 19V6C21 4.895 20.105 4 19 4Z",
		stroke: "#111827",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M13.5377 13.5377C14.5222 12.5531 15.8576 12 17.25 12C18.2884 12 19.3034 12.3079 20.1667 12.8848C21.0301 13.4617 21.703 14.2816 22.1004 15.2409C22.4977 16.2002 22.6017 17.2558 22.3991 18.2742C22.1966 19.2926 21.6965 20.2281 20.9623 20.9623C20.2281 21.6965 19.2926 22.1965 18.2742 22.3991C17.2558 22.6017 16.2002 22.4977 15.2409 22.1003C14.2816 21.703 13.4617 21.0301 12.8848 20.1667C12.3079 19.3034 12 18.2883 12 17.25C12 15.8576 12.5531 14.5223 13.5377 13.5377ZM16.2573 19.7957C15.924 19.9956 15.5 19.7556 15.5 19.3669V15.1331C15.5 14.7444 15.924 14.5044 16.2573 14.7043L19.7854 16.8212C20.1091 17.0154 20.1091 17.4846 19.7854 17.6788L16.2573 19.7957Z",
		fill: "#111827"
	})]
});
const ForwardRef = forwardRef(SvgDateStart);
export default ForwardRef;
